import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const iconLogo = {
  marginRight: "3px",
};
const PhoneLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  paddingRight: "5px",
  marginRight: "5px",
  lineHeight: "0",
  fontSize: "12px",
};
const LinkText = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  fontSize: "12px",
  lineHeight: "12px",
};

function telWithoutSpaces(number) {
  return number.replace(/\s/g, "");
}

export default function Website(website)  {
  return (
    <table style={{borderSpacing: 0}}>
      <tbody>
        <tr>
          <td>
            <img
              src={`https://files.myclientisrich.com/${client}/globe.png`}
              style={iconLogo}
              alt="logo website"
              width="13"
              height="13"
            ></img>
          </td>
          <td>
            <a href={`https://${website.website}`}
              style={PhoneLink}
              >
               <span style={LinkText}>{website.website}</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
